import { IncassoModel } from "../incassi/incasso.model";
import { DizionarioModel } from "../shared/dizionario.model";
/*
Modello utilizzato sia per il dettaglio/lista brogliaccio che per il dettaglio/lista distinta (incasso/versamenti)
*/
export class BrogliaccioDistintaModel {
  /* Campi specifici:
  del brogliacci: in caso di dettaglio brogliaccio
  della distinta Incassi: in caso di dettaglio distinta incassi
  della distinta Versamenti: in caso di dettaglio distinta versamenti
  */
  id:number;
  token:string;   
  nomeUtenteCreatore: string; 
  stato:DizionarioModel;
  dataCreazione:Date;
  
  
  idRaggruppamentoPadre?: string;

  /* 
  nel caso di distinta versamento identifica la data di versamento in banca: 
  è la data di presa in carico della banaca */
  dataPresaInCarico?:Date;


  totaleValuta?: number;                                     
  totaleAssegni?:number;                                      
  totale: number;                                             

  /*
  Unione di tutti gli incassi confluiti:
  nel brogliaccio: in caso di dettaglio brogliaccio
  nei brigliacci appartenenti alla distinta incassi: in caso di dettaglio distinta incassi
  nei brigliacci appartenenti alle distinte incassi appartenenti alla distinta versamenti: in caso di dettaglio distinta versamenti
  */
  incassi?:IncassoModel[];  
  
  /* 
  Info specifiche per la distinta versamento: id banca e numero operazione
  */
  idBanca:  string;
  numeroOperazione: string;
  denominazioneBanca:string;
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/brogliacci/brogliaccio-distinta.model.ts